import { render, staticRenderFns } from "./PizzaLoader.vue?vue&type=template&id=3e3890e7&"
import script from "./PizzaLoader.vue?vue&type=script&lang=ts&"
export * from "./PizzaLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PizzaLoader.vue"
export default component.exports